// Shared colour system + helpers for the Action Tracker (categories, tags, priority, sorting).

export const CATEGORIES = ["Follow-up", "Payment", "Reconciliation", "Approval", "Document", "Client", "Supplier", "Executive", "Other"];

// Stable colour per category (badge classes + accent dot)
export const CATEGORY_COLORS = {
  "Follow-up": { badge: "bg-sky-50 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  "Payment": { badge: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  "Reconciliation": { badge: "bg-violet-50 text-violet-700 border-violet-200", dot: "bg-violet-500" },
  "Approval": { badge: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  "Document": { badge: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-500" },
  "Client": { badge: "bg-teal-50 text-teal-700 border-teal-200", dot: "bg-teal-500" },
  "Supplier": { badge: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  "Executive": { badge: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  "Other": { badge: "bg-gray-100 text-gray-600 border-gray-200", dot: "bg-gray-400" },
};

export const catColor = (cat) => CATEGORY_COLORS[cat] || CATEGORY_COLORS.Other;

// Priority styling
export const PRIORITIES = ["High", "Medium", "Low"];
export const PRIORITY_COLORS = {
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-50 text-slate-600 border-slate-200",
};
const PRIORITY_RANK = { High: 0, Medium: 1, Low: 2 };

// Deterministic colour for a free-text tag (literal classes so Tailwind JIT includes them)
const TAG_PALETTE = [
  "bg-rose-50 text-rose-700 border-rose-200",
  "bg-amber-50 text-amber-700 border-amber-200",
  "bg-emerald-50 text-emerald-700 border-emerald-200",
  "bg-sky-50 text-sky-700 border-sky-200",
  "bg-violet-50 text-violet-700 border-violet-200",
  "bg-teal-50 text-teal-700 border-teal-200",
  "bg-indigo-50 text-indigo-700 border-indigo-200",
  "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "bg-orange-50 text-orange-700 border-orange-200",
  "bg-cyan-50 text-cyan-700 border-cyan-200",
];

export function tagClass(tag) {
  const s = (tag || "").toLowerCase();
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TAG_PALETTE[h % TAG_PALETTE.length];
}

export function sortActions(list, sortBy) {
  const arr = [...(list || [])];
  if (sortBy === "due") {
    arr.sort((a, b) => (a.due_date || "9999-99-99").localeCompare(b.due_date || "9999-99-99"));
  } else if (sortBy === "category") {
    arr.sort((a, b) => (a.category || "").localeCompare(b.category || ""));
  } else if (sortBy === "priority") {
    arr.sort((a, b) => (PRIORITY_RANK[a.priority] ?? 3) - (PRIORITY_RANK[b.priority] ?? 3));
  } else {
    // default: newest assigned first
    arr.sort((a, b) => (b.date_assigned || "").localeCompare(a.date_assigned || ""));
  }
  return arr;
}
